<template>
  <base-picture
    v-if="images"
    v-bind="$attrs"
    :alt="images.alt"
    class="h-full"
    :fetchpriority
    :fit
    :height="images.height"
    :lazy
    :position
    :props-img="{ ...propsImg, class: ['h-full', propsImg?.class] }"
    :src="images.src"
    :width="images.width"
  />
  <vf-video
    v-else
    v-bind="{ ...video, ...$attrs }"
    ref="videoRef"
    :autoplay="!lazy"
    class="h-full"
    :controls
    :fit
    :loop
    :meta="video?.meta?.sm"
  />
</template>

<script lang="ts" setup>
import type { Responsive } from '#types/common'
import type { ImgHTMLAttributes } from '#types/components/base/picture'
import type { ResponsiveMedia } from '#types/content'

defineOptions({ inheritAttrs: false })

const { media, fit = 'cover', controls = true } = defineProps<{
  controls?: boolean
  fit?: 'contain' | 'cover'
  lazy?: boolean
  fetchpriority?: 'high' | 'low' | 'auto'
  media: ResponsiveMedia
  position?: Responsive | string
  propsImg?: ImgHTMLAttributes
  loop?: boolean
}>()

const videoRef = ref<HTMLVideoElement>()
const { images, video } = (media && getResponsiveMedia(media)) || {} as ResponsiveMedia

defineExpose({ videoRef })
</script>
